var render = function render(){var _vm=this,_c=_vm._self._c;return _c('filters-multiselect',{attrs:{"placeholder":_vm.$t('task'),"multiple":true,"model":_vm.searchNameValue,"options":_vm.titleList},on:{"searchItem":_vm.namePage}})
}
var staticRenderFns = []

export { render, staticRenderFns }